<div class="sorting">
  <!-- BY DATE -->
  <div class="sorting-item" (click)="selectSorting(SortingEnum.ByDateDesc)">
    <span class="sorting-date" [class.selected]="state?.selectedSorting === SortingEnum.ByDateDesc">
      {{ translations.sorting[SortingEnum.ByDateDesc] | translate }}
    </span>
  </div>

  <!-- BY POPULARITY -->
  <div class="sorting-item" (click)="selectSorting(SortingEnum.ByWeek)">
    <span class="sorting-popularity" [class.selected]="state?.showPopularityItems">
      {{ translations.sorting.mostPopular | translate }}
    </span>
  </div>

  <div class="sorting-item">
    <santa-select
      *ngIf="state.showPopularityItems"
      class="sorting-popularity-select"
      [items]="state.sortingPopularityItems ?? []"
      [itemContent]="item"
      [selectedValueContent]="current"
      [enableClosedBorder]="false"
      [enableOpenedDivider]="false"
      (itemSelected)="selectSorting($event)"
    ></santa-select>
  </div>
</div>

<ng-template #item let-key let-active="active">
  <p [ngClass]="{ 'santa-bg-black-200 hover:santa-bg-black-100': active }" class="santa-m-0 santa-py-10 santa-whitespace-nowrap">
    {{ translations.sorting[getKeyAsSortingEnum(key)] | translate }}
  </p>
</ng-template>

<ng-template #current let-key>
  <p class="current">
    {{ translations.sorting[getKeyAsSortingEnum(key)] | translate }}
  </p>
</ng-template>
